export function sortBy<T>(array: Array<T>, callbackfn: (value: T) => any): Array<T> {
	return array.slice(0).sort((a, b) => {
		const valA = callbackfn(a)
		const valB = callbackfn(b)
		return valA < valB ? -1 : valA > valB ? 1 : 0
	})
}

export function sortByDesc<T>(array: Array<T>, callbackfn: (value: T) => any): Array<T> {
	return sortBy(array, callbackfn).reverse()
}

export function distinct<T>(array: Array<T>): Array<T> {
	return array.filter((x, i, a) => a.findIndex(y => x === y) === i)
}

export function distinctBy<T>(array: Array<T>, callbackfn: (value: T) => any): Array<T> {
	return array.filter((x, i, a) => a.findIndex(y => callbackfn(x) === callbackfn(y)) === i)
}
